import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { updateTiposHallazgos } from 'actions/configuracionCatalogos.action';
import InfoModal from 'components/InfoModal/InfoModal';
import { Modal, Form } from 'components';
import { MEDIOS_IMPRESOS_SELECTOR } from 'constants/configuracionTiposCatalogos';
// import { listCheckboxAtributos } from 'constants/atributosHallazgos';
import { Row, Col, Input, Select, Spin, Checkbox, message, Tooltip } from 'antd';
import { ReactComponent as InfoCircle } from 'assets/images/InfoCircleExclamation/info_circle_exclamation.svg';
import ModalNotSaveInformation from '../../../components/ModalNotSaveInformation/ModalNotSaveInformation';
import './ModalRegistroTipoMI.scss';

const CheckboxGroup = Checkbox.Group;

const ModalRegistroTipoMI = ({
  open,
  onCancel,
  handleUpdateData,
  initialData,
  arrayValues,
  checkUniqueElement,
  listaAtributos
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [selectedEstatus, setSelectedEstatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openSaveInfModal, setOpenSaveInfModal] = useState(false);
  const [listCheckboxAtributos, setListCheckboxAtributos] = useState([]);

  const defaulCheckedList = initialData ? arrayValues : [];
  const [checkedList, setCheckedList] = useState([]);

  const textMsg = (
    <div style={{ width: '400px', marginLeft: '-50px' }}>Registro guardado exitosamente.</div>
  );

  const handleAceptModal = () => {
    setOpenSaveInfModal(false);
    onCancel();
  };

  const onCheckChange = (list) => {
    console.log('list', list.join(','));
    setCheckedList(list);
  };

  useEffect(() => {
    if (open && initialData) {
      if (initialData?.asignado === 1) form.setFieldValue(['estatus']);
      setListCheckboxAtributos(listaAtributos);
      form.setFieldsValue(initialData);
      setCheckedList(defaulCheckedList);
    } else if (!initialData) {
      setListCheckboxAtributos(listaAtributos);
      form.resetFields();
      setCheckedList([]);
      // console.log('initialData', initialData);
    }
  }, [open]);
  // console.log('indeterminate', indeterminate);
  const checkAll = listCheckboxAtributos?.length === checkedList.length;
  const indeterminate =
    arrayValues?.length > 0 && checkedList?.length < listCheckboxAtributos?.length;
  const optionsFindings = listCheckboxAtributos?.map((item) => item.value);

  const onCheckAllChange = (e) => {
    const { checked } = e.target;
    setCheckedList(checked ? optionsFindings : []);
  };
  // console.log('checkedList out', checkedList);

  const handleOnChange = (e) => {
    setSelectedEstatus(e);
  };
  // console.log('Estatus', selectedEstatus);

  const handleOK = async () => {
    setIsLoading(true);

    try {
      const values = await form.validateFields();
      if (!checkUniqueElement(values.nombreHallazgo)) {
        if (values.descripcion.trim() !== '') {
          const payload = initialData
            ? {
                toUpdate: [
                  {
                    idHallazgo: initialData.idHallazgo,
                    idTipoMonitoreo: MEDIOS_IMPRESOS_SELECTOR,
                    nombreHallazgo: values.nombreHallazgo.trim(),
                    estatus: !selectedEstatus ? values?.estatus : selectedEstatus,
                    descripcion: values.descripcion,
                    atributos: checkedList.join(',')
                  }
                ]
              }
            : {
                toSave: [
                  {
                    idTipoMonitoreo: MEDIOS_IMPRESOS_SELECTOR,
                    nombreHallazgo: values.nombreHallazgo,
                    estatus: !selectedEstatus ? values?.estatus : selectedEstatus,
                    descripcion: values.descripcion,
                    atributos: checkedList.join(',')
                  }
                ]
              };
          const { success, response } = await dispatch(updateTiposHallazgos(payload));
          const codeSucces = response?.data?.tipos_hallazgos?.notSynced?.[0]?.code;
          if (success) {
            if (codeSucces !== 1011) {
              onCancel();
              form.resetFields();
              handleUpdateData();
              setSelectedEstatus(null);
              setIsVisibleSuccessModal(true);
              setCheckedList(defaulCheckedList);
            } else {
              message.error('Ya existe un registro con ese nombre.');
            }
          }
        } else {
          message.error('Ingresa una descripción en el campo.');
        }
      } else {
        message.error('Ya existe un registro con ese nombre.');
      }
    } catch (error) {
      const { errorFields } = error;
      console.log(errorFields);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading && <Spin size="large" />}
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIsVisibleSuccessModal(false);
        }}
        description={textMsg}
      />
      <Modal
        className="custom-registro-tipo-modal"
        centered
        title={initialData ? 'Editar' : 'Agregar'}
        width="85%"
        open={open}
        onCancel={() => {
          setOpenSaveInfModal(true);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, loading: isLoading }}
        okText="Guardar"
        onOk={handleOK}
        destroyOnClose>
        <div>
          <Form layout="vertical" form={form}>
            <div className="modal-formulario-subtitulo" style={{ margin: '30px 0 40px 20px' }}>
              <span className="container-description-form">
                <InfoCircle style={{ margin: '0px 10px 0px 10px' }} />
                <span className="modal-formulario-subtitulo">
                  Captura los datos del tipo de medio impreso.
                </span>
                <span
                  className="modal-formulario-subtitulo-requeridos"
                  style={{ marginLeft: '2em' }}>
                  *Campos obligatorios.
                </span>
              </span>
            </div>
            <Row
              justify="start"
              align="top"
              gutter={[16, 0]}
              style={{ marginLeft: '20px', marginRight: '20px', marginBottom: '40px' }}>
              <Col span={8}>
                <Form.Item
                  label="Nombre del tipo de medio impreso"
                  name="nombreHallazgo"
                  required
                  rules={[{ required: true, message: 'El campo es requerido' }]}>
                  <Input placeholder="Escribe" maxLength={100} />
                </Form.Item>
              </Col>
              <Col span={8}>
                {initialData?.asignado !== 1 ? (
                  <Form.Item
                    required
                    label="Estatus"
                    name="estatus"
                    rules={[{ required: true, message: 'El campo es requerido' }]}>
                    <Select
                      placeholder="Selecciona"
                      onChange={handleOnChange}
                      options={[
                        { value: 0, label: 'Inactivo' },
                        { value: 1, label: 'Activo' }
                      ]}
                      disabled={initialData?.asignado === 1}
                    />
                  </Form.Item>
                ) : (
                  <Tooltip
                    title="No es posible cambiar el estatus, ya que cuenta con monitoreos asignados."
                    placement="bottomLeft"
                    trigger="hover">
                    <Form.Item
                      required
                      label="Estatus"
                      name="estatus"
                      rules={[{ required: true, message: 'El campo es requerido' }]}>
                      <Select
                        placeholder="Selecciona"
                        onChange={handleOnChange}
                        options={[
                          { value: 0, label: 'Inactivo' },
                          { value: 1, label: 'Activo' }
                        ]}
                        value={initialData?.estatus}
                        disabled={initialData?.asignado === 1}
                      />
                    </Form.Item>
                  </Tooltip>
                )}
              </Col>
              <Col span={8}>
                <Form.Item
                  required
                  label="Descripción"
                  name="descripcion"
                  rules={[{ required: true, message: 'El campo es requerido' }]}>
                  <Input.TextArea rows={4} placeholder="Escribe" showCount maxLength={400} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className="modal-formulario-subtitulo" style={{ margin: '30px 0 40px 20px' }}>
            <span className="container-description-small">
              <InfoCircle style={{ margin: '0px 10px 0px 10px' }} />
              <span className="modal-formulario-subtitulo">
                Selecciona los campos que deseas agregar.
              </span>
            </span>
          </div>
          <Row>
            <Form layout="vertical">
              <Form.Item name="checkboxes">
                <Col span={24} push={2}>
                  <Row justify="start" style={{ marginBottom: '30px' }}>
                    {/* Seleccionar todos los Checkbox */}
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChange}
                      checked={checkAll}>
                      Seleccionar / deseleccionar todo
                    </Checkbox>
                  </Row>
                </Col>
                {/* Selección de checkboxes Individual  */}
                <Col span={24}>
                  <Row gutter={64}>
                    <CheckboxGroup
                      style={{ width: '100%' }}
                      value={checkedList}
                      onChange={onCheckChange}>
                      {listCheckboxAtributos?.map((item) => (
                        <Col span={6} push={2}>
                          <div key={item.value} style={{ marginBottom: '20px' }}>
                            <Checkbox value={item.value} id={`checkbox-${item.value}`}>
                              {item.label}
                            </Checkbox>
                          </div>
                        </Col>
                      ))}
                    </CheckboxGroup>
                  </Row>
                </Col>
              </Form.Item>
            </Form>
          </Row>
        </div>
      </Modal>
      <ModalNotSaveInformation
        open={openSaveInfModal}
        handleAceptModal={handleAceptModal}
        setOpenSaveInfModal={setOpenSaveInfModal}
      />
    </div>
  );
};

ModalRegistroTipoMI.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  handleUpdateData: PropTypes.func.isRequired,
  initialData: PropTypes.shape({
    asignado: PropTypes.number,
    atributos: PropTypes.string,
    descripcion: PropTypes.string,
    estatus: PropTypes.number,
    idHallazgo: PropTypes.number,
    idTipoMonitoreo: PropTypes.number,
    nombreHallazgo: PropTypes.string,
    subTipoHallazgos: PropTypes.arrayOf({
      idTipoHallazgo: PropTypes.number,
      nombreTipoHallazgo: PropTypes.string
    })
  }),
  arrayValues: PropTypes.arrayOf(PropTypes.number),
  checkUniqueElement: PropTypes.func.isRequired,
  listaAtributos: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    })
  ).isRequired
};

ModalRegistroTipoMI.defaultProps = {
  open: false,
  initialData: null,
  arrayValues: []
};

export default ModalRegistroTipoMI;
